import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import UsersListReport from "../components/UserListReport";


const UsersListPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
           <Breadcrumb title="Report - Users List" />

        {/* UsersListLayer */}
        <UsersListReport />

      </MasterLayout>

    </>
  );
};

export default UsersListPage; 
